module.exports = __webpack_public_path__ + "img/set.b90f542f.png";